import { connect } from 'react-redux';

import ImageCropper from './image_cropper/image_cropper_container.jsx';

import {
  showErrorNotification
} from 'zoomforth_codesbane_editor/action_creators/misc.js';

import {
  closeModal
} from 'zoomforth_codesbane_editor/action_creators/editor_modals.js';

import {
  createCroppedImageForSectionBackground
} from 'zoomforth_codesbane_editor/action_creators/cropper.js';

import {
  getDefaultSectionBackgroundAssetRatio
} from 'zoomforth_codesbane_viewer/lib/section_backgrounds.js';

const mapStateToProps = (state, { section, imageSrc }) => {
  const { sizex, sizey } = getDefaultSectionBackgroundAssetRatio(section);

  return {
    aspectRatio: sizex / sizey,
    imageSrc
  };
};

const mapDispatchToProps = (dispatch, { contentItem, section }) => (
  {
    onCancel: ()=> {
      dispatch(closeModal());
    },
    onCrop: (image)=> { 
      dispatch(createCroppedImageForSectionBackground(contentItem, section, image));
      dispatch(closeModal());
    },
    onCropFail: (message)=> {
      dispatch(showErrorNotification(
        'Cropping failed',
        `Image cropping failed with the error "${message}".  Please try again and contact support if the problem persists.`
      ));
    }
  }
);

const TileCropperModal = connect(
  mapStateToProps,
  mapDispatchToProps

)(ImageCropper);

TileCropperModal.editorModalName = 'SectionBackgroundAssetCropperModalContainer';

export default TileCropperModal;
